import { createLogger } from '@/logger';
import { createUser } from './cognito';

const log = createLogger('auth.reset');

function errorToFriendlyMessage(err) {
  if (err.code === 'UserNotFoundException') {
    return 'No user with that email.';
  }

  log.error({
    message: 'Encountered unmatched error during password reset.',
    exception: err,
  });

  return err.message;
}

export function requestReset({ username, success, error }) {
  const user = createUser(username);

  user.forgotPassword({
    onSuccess: () => {
      log.information({ message: `Password reset request for ${username}.` });
      success();
    },
    onFailure: err => error(errorToFriendlyMessage(err)),
  });
}

export function completeReset({ username, code, password, success, error }) {
  const user = createUser(username);

  user.confirmPassword(code, password, {
    onSuccess: () => {
      log.information({ message: `Password reset completed for ${username}.` });
      success();
    },
    onFailure: err => error(errorToFriendlyMessage(err)),
  });
}



// WEBPACK FOOTER //
// ./src/auth/reset.js